import { createRootRouteWithContext, Outlet, useRouter } from "@tanstack/react-router";
import type { QueryClient } from "@tanstack/react-query";
import { useEffect } from "react";
import { useAuth } from "@/lib/auth";

interface RouterContext {
  queryClient: QueryClient;
  auth: ReturnType<typeof useAuth>;
}

export const Route = createRootRouteWithContext<RouterContext>()({
  component: RootComponent,
});

function RootComponent() {
  const { loading } = useAuth();
  const router = useRouter();
  useEffect(() => { router.invalidate(); }, [router]);
  if (loading) return <FullScreenSpinner />;
  return <Outlet />;
}

function FullScreenSpinner() {
  return (
    <div className="grid h-screen place-items-center text-muted-foreground">
      <div className="flex flex-col items-center gap-3">
        <div className="h-8 w-8 animate-spin rounded-full border-2 border-current border-t-transparent" />
        <span className="text-sm">Loading…</span>
      </div>
    </div>
  );
}
